import { all, call, takeLatest } from 'redux-saga/effects';
import { deleteKeyWords, editKeyWord, getKeyWords, createKeyWords } from 'api/keyWords';
import { KEYWORDS_ACTION_TYPES } from '../actions/keyWords.actions';

function* loadKeyWords(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(getKeyWords, payload);
    resolve({
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    });
  } catch (e) {
    reject(e.response.data);
  }
}

function* deleteKeyWord(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(deleteKeyWords, payload);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* editKeyWords(action) {
  const { payload, resolve, reject } = action;
  try {
    const data = yield call(editKeyWord, payload);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* createdKeyWords(action) {
  const { payload, resolve, reject } = action;
  try {
    const data = yield call(createKeyWords, payload);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}


export default function* () {
  yield all([
    takeLatest(KEYWORDS_ACTION_TYPES.LOAD_KEYWORDS, loadKeyWords),
    takeLatest(KEYWORDS_ACTION_TYPES.DELETE_KEYWORDS, deleteKeyWord),
    takeLatest(KEYWORDS_ACTION_TYPES.EDIT_KEYWORDS, editKeyWords),
    takeLatest(KEYWORDS_ACTION_TYPES.CREATE_KEYWORDS, createdKeyWords),
  ]);
}